import styled from 'react-emotion';

import Style from '../../styles/common';

const Label = styled('label')`
  display: block;
  font-size: ${Style.FONT_SIZE.M};
  font-weight: ${Style.FONT_WEIGHT.MEDIUM};
  letter-spacing: 0.5px;
  padding: 1rem .25rem;
`;

export default Label;



// WEBPACK FOOTER //
// ./src/components/Form/Label.js